'use client';
var classes = {"tooltip":"m_e4d36c9b","tooltipLabel":"m_7f4bcb19","tooltipBody":"m_3de554dd","tooltipItemColor":"m_b30369b5","tooltipItem":"m_3de8964e","tooltipItemBody":"m_50186d10","tooltipItemName":"m_501dadf9","tooltipItemData":"m_50192318"};

export { classes as default };
//# sourceMappingURL=ChartTooltip.module.css.mjs.map
